import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";
import { FAQS } from "@/data/content";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 lg:py-32 bg-cream/60">
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        <SectionHeading
          align="center"
          chapter="12"
          overline="FAQ"
          title="Questions, Answered Honestly"
          sub="Everything patients and franchise aspirants usually ask us."
        />
        <Reveal className="mt-14">
          <Accordion type="single" collapsible className="rounded-3xl bg-white border border-pine/10 shadow-soft px-6 md:px-10 py-2">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-b border-pine/8 last:border-0">
                <AccordionTrigger data-testid={`faq-question-${i}`} className="py-5 text-left font-display text-base md:text-lg font-semibold text-pine-deep hover:text-teal-brand hover:no-underline transition-colors">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-answer-${i}`} className="pb-5 text-sm md:text-base leading-relaxed text-slate-600">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
